import { Injectable } from '@angular/core';
import { AuthHttp, JwtHelper } from 'angular2-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as _ from 'underscore';
import * as moment from 'moment'
import { environment } from '../../environments/environment';
import { Cookie } from 'ng2-cookies';

import 'rxjs/add/operator/map'
import 'rxjs/add/operator/toPromise';
import { Headers } from '@angular/http';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Injectable()
export class ApiService {

	private endpoint = environment.apiEndpoint
	private loginEndpoint = environment.membrsEndpoint
  private loginPage = environment.membrsLoginPage
  private cookieDomain = environment.cookieDomain

  private _token:string
  private useAuth:boolean
  
  constructor(private jwtHelper: JwtHelper, private authHttp: AuthHttp, private http: HttpClient) {

   
  }

  decode(){
    console.log(this.token,'this.token')
  	if(!this.token)
  		return
  	// var result = this.jwtHelper.decodeToken(this.token)
    var base64Url = this.token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    var result = JSON.parse(jsonPayload);

  	return result
  }

  reissue(token){
    // returns a promise
    console.log(token,'in reissue token');
    return new Promise((resolve, reject) => {
      this.token = token;
      resolve(this.token);
    });
   

    // return new Promise((resolve, reject) => {
    //   this.http.get(this.loginEndpoint+'/token/'+token+'/reissue').subscribe((data:any) => {

    //     this.token = data.token
    //     resolve(data.token)
    //   }, err => {
    //     console.log('token rejected');
    //     reject()
    //   });

    // })

  }

  useAuthHeader(useAuth){
    
    this.useAuth = useAuth

  }

  logout(){
//
      
      localStorage.clear();
      
      if(window.location.hostname == 'nextgen.marketplace.worryandpeace.com'){
        window.location.href = 'https://apollo11.gonextgen.co.uk'
      }
      else
      {
        window.location.href = this.loginPage
      }
 
  }

  set token(token){

    console.log(token,'Token in set token');

    this._token = token

    Cookie.set('membrs',token,1,'/',this.cookieDomain);

  }

  setAdminId(){

    localStorage.setItem('adminId', this.decode().adminId);
  
  }

  get token(){


    // to-do: check that the token is valid
    if(!Cookie.check('membrs')){
      this.logout();
    }


    // if(this.jwtHelper.isTokenExpired(Cookie.get('membrs')) == true){

    //   this.logout();
    // }


  	return Cookie.get('membrs')
  }

  get adminId(){

    var adminId = this.decode().adminId

    return adminId;
  }


  get loginUrl(){
    return this.loginPage
  }

  get apiEndpoint(){

    return this.endpoint;
  }


  request(method:string, path:string, params?:any, body?:any): Promise<any>{

    if(path.startsWith('http')){
      var endpoint = '';
    }
    else
    {
      var endpoint = this.endpoint;
    }

  	_.each(params, (value, key)=> {
	    path = path.replace(new RegExp(':'+key+'(\\W|$)', 'g'), function(match, p1) {
	        return value + p1;
	    });	    
    });

    
  
  	// switch method
  	switch(method){
  		case 'GET':
        return this.http.get(endpoint+path, {
          headers: this.headers
        }).toPromise().then(this.extractData
        ).catch(this.handleError)

        // this.http.get(endpoint+path, {
        //   headers: this.headers
        // }).toPromise()

  			// return this.http.get(endpoint+path, {
        //   headers: this.headers
        // })
		    //   .toPromise().then(this.extractData)
        //   .catch(this.handleError)
        // return this.authHttp.get(endpoint+path)
        // .toPromise().then((data)=> {
        //   debugger;
        //   this.extractData
        // }
        //  )
        // .catch(this.handleError)

  		case 'POST':

  			// return this.authHttp.post(endpoint+path, body)
        // .toPromise().then(this.extractData)
        // .catch(this.handleError)

       return  this.http.post(endpoint+path, body,{
          headers: this.headers
        }).toPromise().then(this.extractData
          ).catch(this.handleError)
		  
  		case 'PUT':

      // return this.http.put(endpoint+path, body)
      //   .toPromise().then(this.extractData)
      //   .catch(this.handleError)
      return this.http.put(endpoint+path, body,{
        headers: this.headers
      }).toPromise().then(this.extractData
      ).catch(this.handleError)

  		case 'DELETE':

        return this.http.delete(endpoint+path,{
          headers: this.headers
        }).toPromise().then(this.extractData).catch(this.handleError)

      // return this.http.delete(endpoint+path)
      //     .toPromise().then(this.extractData)
      //     .catch(this.handleError)

  		default: 

  		break;
  	}

  } 

  get headers() {

    if(this.useAuth == true){
      return new HttpHeaders({
        'authorization': 'NxbKs9RJf8-rWrqZGv2Ct-qGPq27VUEC'
      });
    }
    else{
      return new HttpHeaders({
        'x-authorization': Cookie.get('membrs')
      });
    }

    

   

  }




  

  // addPod(pod): Promise<any>{
  //         return this._http.post(this._url, pod).toPromise().then(this.extractData)
  //         .catch(this.handleError)
  //     }

  extractData(value: any) {
    console.log(value,'value in extract data')
    if(!value.data && value.status == 200){
      console.log('value data is false')
      return { status: value.status };
    }
  else if(typeof value.data === 'string'){
    return value
    
  } else {
    console.log('value data is true')
    let body = value.data;
    body.status = value.status
    return  body
  

  }
        
  }

  extractOriginal(value){
    if(value._body.length == 0 && value.status == 200){
      return { status: value.status };
  }
  else{

      let json = value.json()

       if(json.data !== null){
      try{
        let body = json.data;
        if(json.message && json.data)
          body.response_message = json.message
        // to-do: get rid of this
          body.status = value.status
        return body
      }catch(error){

        return { status: value.status }
      }
    }
    else{
      
      return { status: value.status }
    }
    
  }
  }

  private handleError(error:any): Promise<any> {
        console.log(error,'Error passed into handlError')
        if(!error.message){
          var body = JSON.parse(error._body)
          error.message = body.message
        }
        return Promise.reject(error.message || 'An unknown error occured, please try again');
    
  }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/api-service/api.service.ts